import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Pages that should NOT have swipe-back (main tabs)
const NO_SWIPE_BACK_ROUTES = [
  '/dashboard',
  '/workouts', 
  '/progress',
  '/food-log',
  '/recovery',
  '/auth',
  '/onboarding',
];

export const useSwipeBack = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const touchStartX = useRef(0);
  const touchStartY = useRef(0);
  const isSwiping = useRef(false);

  useEffect(() => {
    // Check if current route should allow swipe-back
    const shouldAllowSwipeBack = !NO_SWIPE_BACK_ROUTES.some(
      route => location.pathname === route || location.pathname === '/'
    );

    if (!shouldAllowSwipeBack) return;

    const handleTouchStart = (e: TouchEvent) => {
      const touch = e.touches[0];
      // Only trigger if starting from left edge (within 30px)
      if (touch.clientX <= 30) {
        touchStartX.current = touch.clientX;
        touchStartY.current = touch.clientY;
        isSwiping.current = true;
      }
    };

    const handleTouchMove = (e: TouchEvent) => {
      if (!isSwiping.current) return;
      
      const touch = e.touches[0];
      const deltaX = touch.clientX - touchStartX.current;
      const deltaY = Math.abs(touch.clientY - touchStartY.current);
      
      // If vertical movement is greater, cancel the swipe
      if (deltaY > 50) {
        isSwiping.current = false;
      }
    };

    const handleTouchEnd = (e: TouchEvent) => {
      if (!isSwiping.current) return;
      
      const touch = e.changedTouches[0];
      const deltaX = touch.clientX - touchStartX.current;
      const deltaY = Math.abs(touch.clientY - touchStartY.current);
      
      // Swipe right from left edge: deltaX > 80px and mostly horizontal
      if (deltaX > 80 && deltaY < 100) {
        navigate(-1);
      }
      
      isSwiping.current = false;
    };

    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [location.pathname, navigate]);
};

